export default "__VITE_ASSET__80ee86ee__"